import React, { useState, useEffect, useMemo } from 'react'
import { motion } from 'framer-motion'
import { IoIosArrowBack } from "react-icons/io";
import { LuUpload } from "react-icons/lu";
import { useNavigate } from 'react-router-dom';
import DriverService from '../../../services/Driver';
import FileService from '../../../services/file';
import CustomInput from '../../../Modals/filter modal/Input';
import CargoService from '../../../services/Cargo';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../redux/slices/toastSlice';
import Toast from '../../../Modals/toast/Toast';
import ProfileCargoService from '../../../services/ProfileCargo';

export default function RegisterInfo({ images = {} }) {
    const [carTypes, setCarTypes] = useState([]); 
    const [loadingBtn,setLoadingBtn]=useState(false)
    const [loadingFile1,setLoadingFile1]=useState(false)
    const [loadingFile2,setLoadingFile2]=useState(false)




    const dispatch=useDispatch()


    async function checkProf(){
        try{
            const res=await ProfileCargoService.getMyProfile()
            const data=res?.data?.data
            if(res.status===200){
               if(data?.driver_Completion){
                navigate("/driver/dashboard")   
               }else{
                return
               }
            }

        }catch(err){
            console.log(err)
        }

    }

    useEffect(()=>{
        checkProf()
    },[])

    useEffect(() => {
        const fetchCarTypes = async () => {
            try {
                const res = await CargoService.getAllCarType();
                setCarTypes(res?.data?.data || []);
            } catch (err) {
                setCarTypes([]);
            }
        };
        fetchCarTypes();
    }, []);


    const carTypeOptions = useMemo(() => {
        return (carTypes || []).map((ct) => {
            const value = ct && (ct._id || ct.id) ? (ct._id || ct.id) : ct;
            const label = (ct && (ct?.label + "-"+ ct?.name)) || String(value || '');
            return { label, value };
        });
    }, [carTypes]);

    const navigate = useNavigate();

    const [form, setForm] = useState({
        plate1: "",
        plate2: "",
        plate3: "",
        plate4: "",
        smartCard: "",
        carType: "",
        internationalPlate: ""
    });
    const [errors, setErrors] = useState({});
    const [isInternational, setIsInternational] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadedFile2, setUploadedFile2] = useState(null);

    const [image, setImage] = useState(null);
    const [image2, setImage2] = useState(null);


    async function uploadImage1(file){
        setUploadedFile(file)
      
            setLoadingFile1(true)
            const fd1 = new FormData();
            fd1.append("file", file);
            try{
            const res1 = await FileService.uploadFile(fd1);
           
           
            if(res1?.data?.status==200){
                console.log("📤 فایل اول آپلود شد:", res1.data);
                
                setImage(res1?.data?.message?._id);
                dispatch(showToast({message:"تصویر با موفقیت آپلود شد",type:"success"}))
            }
            }catch(err){
                console.log(err)
                setUploadedFile(null)
                dispatch(showToast({message:"خطا در آپلود تصویر",type:"error"}))
            }finally{
                setLoadingFile1(false)
            }
            
          
    

    }

    async function uploadImage2(file){
        setUploadedFile2(file)

     
            setLoadingFile2(true)
            const fd2 = new FormData();
            fd2.append("file", file);
            try{
                const res2 = await FileService.uploadFile(fd2);
             
                if(res2?.status==200){
              
                    setImage2(res2?.data?.message?._id);
                    dispatch(showToast({message:"تصویر با موفقیت آپلود شد",type:"success"}))
                    
    
                }
               
            }catch(err){
                setUploadedFile2(null)
                dispatch(showToast({message:"خطا در آپلود تصویر",type:"error"}))
            }finally{
                setLoadingFile2(false)
            }
           

        
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));

        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!form.plate1 || !form.plate2 || !form.plate3 || !form.plate4) {
            newErrors.plate = "پلاک معتبر نیست";
        }
        if (!form.smartCard) newErrors.smartCard = "شماره کارت الزامی است";
        if (form.carType==="") newErrors.carType = "مدل خودرو الزامی است";
        if (!uploadedFile) newErrors.uploadedFile = "آپلود تصویر الزامی است";
        if (!uploadedFile2) newErrors.uploadedFile2 = "آپلود تصویر الزامی است";
        if (isInternational && !form.internationalPlate) {
            newErrors.internationalPlate = "پلاک بین المللی الزامی است";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        setLoadingBtn(true)

        try {
            const fileIds = [];
            fileIds.push(image)
            fileIds.push(image2)
         
            

            const body = {
                NumberOfdigitalcard: form.smartCard,
                International_Plate: form.internationalPlate || null,
                LicensePlate1: form.plate1,
                LicensePlate2: form.plate2,
                LicensePlate3: form.plate3,
                LicensePlate4: form.plate4,
                cartype: form.carType,
                driver_license_image: fileIds

            };


            console.log("📤 ارسال به سرور:", body);

            const res = await DriverService.updateDriverInfo(body);
            dispatch(showToast({message:"اطلاعات شما با موفقیت تکمیل شد",type:"success"}))
            setTimeout(() => {
                navigate('/driver/dashboard');
            }, 1000);
    

        } catch (err) {
            dispatch(showToast({message:err?.data?.data?.message || "خطا در تکمیل اطلاعات",type:"error"}))
            alert("مشکلی در ثبت اطلاعات پیش آمد");
        }finally{
            setLoadingBtn(false)
        }
    };

   
    const shakeAnimation = {
        x: [0, -6, 6, -6, 6, 0],
        transition: { duration: 0.4 }
    };
    const container = {
        hidden: { opacity: 0, y: 8 },
        show: { opacity: 1, y: 0, transition: { staggerChildren: 0.08, when: 'beforeChildren' } }
    };
    const item = {
        hidden: { opacity: 0, y: 12 },
        show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } }
    };

    const { international = '/icon-512.png' } = images;




    return (
        <>
        <Toast></Toast>
        <div className="w-full flex justify-center items-center flex-col gap-10 min-h-screen py-10 lg:px-10 px-5">
            <motion.section
                className="flex justify-start items-start flex-col gap-5 max-w-6xl w-full mx-auto"
                variants={container}
                initial="hidden"
                animate="show"
                dir="rtl"
            >

                {/* هدر */}
                <motion.div variants={item} className="flex flex-row justify-between w-full h-max">
                    <img className="w-[80px] object-contain" src={international} alt="logo" />
                    <button onClick={() => { navigate('/driver') }} className="flex gap-1 cursor-pointer hover:scale-105 transition-all duration-200 text-special text-md">
                        <span>بازگشت</span>
                        <IoIosArrowBack className='text-special' strokeWidth={1} size={20} />
                    </button>
                </motion.div>

                <motion.p variants={item} className='block text-gray-400 text-[14px] lg:w-1/2 w-full leading-relaxed'>
                    برای شروع نیاز به اطلاعاتی جهت ارائه خدمات بهتر برای ثبت بار به شما داریم. قابل توجه: تضمین حفظ اطلاعات شما با بارسرا می‌باشد.
                </motion.p>
                <motion.div variants={item} className="flex flex-row justify-start items-center gap-5 h-max w-full">
                    <div className="h-[40px] w-[10px] rounded-lg bg-special" />
                    <p className='text-gray-500 text-2xl font-bold text-[18px]'>لطفا جهت پذیرش بار در بارسرا اطلاعات خود را تکمیل کنید</p>
                </motion.div>

                {/* فرم */}
                <motion.div variants={item} className="flex flex-col sm:flex sm:flex-wrap gap-8 w-full">
                    <div className="flex flex-col justify-center w-full">
                        <div className="flex flex-col lg:flex-row lg:justify-between lg:px-24 gap-8 lg:gap-0">
                            <div className='flex flex-col gap-4 pt-10'>
                                {/* پلاک ماشین */}
                                <label className="flex flex-col sm:flex-row sm:items-center gap-2 text-gray-600 text-sm">
                                    <span className='w-full text-md sm:w-[150px] text-start'>پلاک ماشین</span>
                                    <div className="flex items-center gap-2 flex-wrap">
                                        {["plate4", "plate3", "plate2", "plate1"].map((key, idx) => (
                                            <div className="flex flex-col items-center" key={key}>
                                                <motion.input
                                                    name={key}
                                                    type={(key === "plate3" || key === "plate1" ) ? "text" : "number"}
                                                    inputMode={key === "plate2" ? "text" : "numeric"}
                                                    placeholder={["33", "ن", "985", "ایران"][idx]}
                                                    value={form[key]}
                                                    onChange={handleChange}
                                                    className={`w-[70px] h-12 border border-special rounded-2xl px-2 text-center ${errors.plate ? "border-red-500" : ""}`}
                                                    animate={errors.plate ? shakeAnimation : {}}
                                                    style={errors.plate ? { borderColor: 'rgb(239 68 68)' } : {}}
                                                />
                                             
                                            </div>
                                        ))}

                                    </div>
                                </label>

                                {/* شماره کارت هوشمند */}
                                <label className="flex flex-col sm:flex-row sm:items-center my-2 gap-2 text-gray-600 text-sm">
                                    <span className='w-full text-md sm:w-[150px] text-start'>شماره کارت هوشمند ناوگان</span>
                                    <motion.input
                                        type="text"
                                        name="smartCard"
                                        placeholder="052585258996"
                                        value={form.smartCard}
                                        onChange={handleChange}
                                        className={`w-full sm:max-w-[229px] h-12 border border-special rounded-2xl px-3 ${errors.smartCard ? "border-red-500" : ""}`}
                                        animate={errors.smartCard ? shakeAnimation : {}}
                                        style={errors.smartCard ? { borderColor: 'rgb(239 68 68)' } : {}}
                                    />
                                    {errors.smartCard && (
                                        <span className="text-red-500 text-xs mt-1" >  شماره کارت هوشمند الزامی است</span>
                                    )}

                                </label>

                                {/* نوع خودرو */}
                                <CustomInput
                                    label="نوع خودرو"
                                    type="option"
                                    items={carTypeOptions}
                                    val={form.carType}
                                    setVal={(v) => {
                                        const normalized = v === undefined ? null : v;
                                        setForm(prev => ({ ...prev, carType: normalized }));
                                    }}
                                    error={errors.carType}
                                />


                                {/* چک‌باکس */}
                                <div className="flex-col items-center my-2 mt-6 sm:mt-10">
                                    <div className='flex items-center gap-3 mb-5'>
                                        <input
                                            type="checkbox"
                                            id="international"
                                            className="w-5 h-5"
                                            checked={isInternational}
                                            onChange={(e) => setIsInternational(e.target.checked)}
                                        />

                                        <label htmlFor="international" className="text-gray-600 text-sm">
                                            وسیله نقلیه من دارای پلاک بین‌المللی است.
                                        </label>
                                    </div>

                                    {isInternational && (
                                        <label className="flex flex-col sm:flex-row sm:items-center my-2 gap-2 text-gray-600 text-sm">
                                            <span className='w-full text-md sm:w-[150px] text-start'>پلاک بین المللی ماشین</span>
                                            <motion.input
                                                type="text"
                                                name="internationalPlate"
                                                placeholder="22 A 928 10"
                                                value={form.internationalPlate}
                                                onChange={handleChange}
                                                className={`w-full sm:max-w-[229px] h-12 border border-special rounded-2xl px-3 ${errors.internationalPlate ? "border-red-500" : ""}`}
                                                animate={errors.internationalPlate ? shakeAnimation : {}}
                                                style={errors.internationalPlate ? { borderColor: 'rgb(239 68 68)' } : {}}
                                            />
                                            {errors.internationalPlate && (
                                                <span className="text-red-500 text-xs mt-1">الزامی است</span>
                                            )}
                                        </label>
                                    )}

                                </div>
                            </div>
                            <div className='flex-col w-full sm:w-[350px] text-center'>
                                <p className="text-xs text-center px-4 sm:px-10 mb-2 text-gray-400">
                                    لطفاً تصویر گواهینامه خود را در کادر بالا بارگذاری کنید. مطمئن شوید که تصویر واضح و خوانا باشد تا اطلاعات به‌درستی ثبت شود.
                                </p>
                                {/* آپلود */}
                                <div className='mb-4'>
                                    <motion.div
                                        className={`w-full h-40 border rounded-xl bg-gray-50 cursor-pointer flex items-center justify-center overflow-hidden ${errors.uploadedFile ? "border-red-500" : "border-special"}`} // ظاهر تمیز و کنترل‌شده
                                        animate={errors.uploadedFile ? shakeAnimation : {}} 
                                    >
                                        <label htmlFor="file-upload" className="w-full h-full flex items-center justify-center">
                                            {!uploadedFile ? (
                                                <LuUpload className="text-gray-400 text-4xl" /> 
                                            ) : (
                                                <img
                                                    src={URL.createObjectURL(uploadedFile)}
                                                    alt="گواهینامه"
                                                    className={`${loadingFile1 && "animate-pulse"} w-full h-full object-contain rounded-xl`}
                                                />
                                            )}
                                        </label>
                                        <input
                                            type="file"
                                            name="uploadedFile"
                                            className="hidden"
                                            id="file-upload"
                                            accept="image/*"
                                            onChange={(e) => {
                                           
                                                uploadImage1(e.target.files[0])
                                              
                                            }}
                                        />
                                    </motion.div>

                                    {errors.uploadedFile && (
                                        <span className="text-red-500 text-xs mt-2 block">تصویر گواهینامه الزامی است</span>
                                    )}

                                    <p className="text-xs text-center px-4 sm:px-10 mt-1 text-gray-400">
                                        روی اول گواهی نامه
                                    </p>
                                </div>

                 
                                <div>
                                    <motion.div
                                        className={`w-full h-40 border rounded-xl bg-gray-50 cursor-pointer flex items-center justify-center overflow-hidden ${errors.uploadedFile2 ? "border-red-500" : "border-special"}`} // ظاهر تمیز و کنترل‌شده
                                        animate={errors.uploadedFile2 ? shakeAnimation : {}} 
                                    >
                                        <label htmlFor="file-upload2" className="w-full h-full flex items-center justify-center">
                                            {!uploadedFile2 ? (
                                                <LuUpload className="text-gray-400 text-4xl" /> 
                                            ) : (
                                                <img
                                                    src={URL.createObjectURL(uploadedFile2)}
                                                    alt="گواهینامه"
                                                    className={`${loadingFile2 && "animate-pulse"} w-full h-full object-contain rounded-xl`}
                                                />
                                            )}
                                        </label>
                                        <input
                                            type="file"
                                            name="uploadedFile2"
                                            className="hidden"
                                            id="file-upload2"
                                            accept="image/*"
                                            onChange={(e) => {
                                                uploadImage2(e.target.files[0])

                                            }}
                                        />
                                    </motion.div>

                                    {errors.uploadedFile2 && (
                                        <span className="text-red-500 text-xs mt-2 block">تصویر گواهینامه الزامی است</span>
                                    )}
                                    <p className="text-xs text-center px-4 sm:px-10 mt-1 text-gray-400">
                                        روی دوم گواهی نامه
                                    </p>

                                </div>
                            </div>


                        </div>



                        <div className="flex mt-7 w-full pt-2 border-t-[1px] border-special justify-end lg:px-14">

                            {/* دکمه ثبت */}
                            <motion.button
                                onClick={handleSubmit}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className={`bg-special ${loadingBtn && "bg-opacity-75"} text-white cursor-pointer rounded-xl px-6 py-3 w-full sm:w-28`}
                            >
                                {
                                    loadingBtn?
                                    <p>در حال ثبت</p>
                                    :
                                    <p>ثبت</p>

            
                                }
                               

                            </motion.button>

                        </div>
                    </div>
                </motion.div>
            </motion.section>
        </div>
        </>
    )
}
